import React, { useEffect } from 'react';
import { Modal, Form, Button, Checkbox, Radio, Select, DatePicker, Input } from 'antd';

const { RangePicker } = DatePicker;

const ExportOptionsModal = ({
  visible,
  onCancel,
  onExport,
  exportColumns = [],
  filterOptions = [],
  textFilter, // if it's not passed, it will be undefined.
  isLoading = false
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleOk = () => {
    form.submit();
  };

  return (
    <Modal
      title="Advanced Export Options"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" loading={isLoading} onClick={handleOk}>
          Download Report
        </Button>,
      ]}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onExport}
        initialValues={{
          format: 'pdf',
          columns: exportColumns.map(c => c.value),
        }}
      >
        <Form.Item name="columns" label="Select Columns to Export" rules={[{ required: true, message: 'Please select at least one column.' }]}>
          <Checkbox.Group options={exportColumns} />
        </Form.Item>
        
        <Form.Item name="dateRange" label="Filter by Creation Date Range (Optional)">
          <RangePicker style={{ width: '100%' }} />
        </Form.Item>

        {/* THE FIX: Conditionally render this Form.Item only if the textFilter prop is provided */}
        {textFilter && (
          <Form.Item name={textFilter.name} label={`${textFilter.label} (Optional)`}>
            <Input placeholder={textFilter.placeholder} allowClear />
          </Form.Item>
        )}
        
        {filterOptions.map(filter => (
          <Form.Item key={filter.key} name={filter.name} label={`Filter by ${filter.label} (Optional)`}>
            <Select mode="multiple" allowClear placeholder={`Select ${filter.label.toLowerCase()} to include`}>
              {filter.options.map(opt => (
                <Select.Option key={opt.value} value={opt.value}>{opt.text}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        ))}

        <Form.Item name="format" label="Select Export Format" rules={[{ required: true, message: 'Please select an export format.' }]}>
          <Radio.Group>
            <Radio.Button value="pdf">PDF</Radio.Button>
            <Radio.Button value="csv">CSV</Radio.Button>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ExportOptionsModal;